<template>
  <div class="container">
    <div class="row">
      <h4 v-if="title">{{ title }}</h4>
    </div>
    <div
      class="input-group mb-3"
      v-show="!loading"
    >
      <input
        v-model="search"
        type="text"
        class="form-control"
        placeholder="Buscar opcion"
        aria-label="Buscar opcion"
        aria-describedby="input-search"
      >
      <div class="input-group-append">
        <button
          class="btn btn-outline-secondary"
          type="button"
          v-b-tooltip="'Agregar nueva opción'"
          v-on:click="addOptionNew()"
        >
          <feather-icon icon="PlusIcon"/>
        </button>
      </div>
    </div>
    <div v-show="!loading">
      <TreeItem
        class="item"
        :key="page"
        :is-open-initial="true"
        :item="filteredTree"
      >
        <template
            slot="folder-description"
            slot-scope="{item}"
        >
          <div>
            <feather-icon
                icon="PlusIcon"
                v-if="item.levelNode < childrenLevelsLimit"
                v-on:click="addOptionNew(item.optionId)"
            />
            <b-icon
                v-if="item.levelNode"
                class="mr-1 cursor-pointer"
                icon="pencil"
                @click="mapAndEditOption(item)"
            />
            {{ item.name || '--' }}
          </div>
        </template>
        <template
            slot="item-description"
            slot-scope="{item}"
        >
          <ul>
            <li>
              <feather-icon
                icon="PlusIcon"
                v-if="item.levelNode < childrenLevelsLimit"
                v-on:click="addOptionNew(item.optionId)"
              />
              <feather-icon
                @click="mapAndDeleteOption(item)"
                icon="TrashIcon"
                color="red"
                class="mr-1 cursor-pointer"
                v-b-tooltip="'Ocultar opción'"
              />
              <b-icon
                class="mr-1 cursor-pointer"
                icon="pencil"
                @click="mapAndEditOption(item)"
              />
              {{ item.name }}
            </li>
          </ul>
        </template>
      </TreeItem>
      <div class="col-12 mt-5 mb-3">
        <fb-paginacion
          :total="pagination.pages"
          :max="10"
          v-model="page"
          @change="handlePageChange"
        />
      </div>
    </div>
    <b-spinner
      v-if="loading"
      key="primary"
      class="mr-1"
      variant="primary"
    />
    <option-edition-modal
        :value-type-config="valueTypeConfig"
        :extra-type-render="extraTypeRender"
        ref="option-modal"
        v-on:saved="savedOption"
    />
    <option-migration-modal ref="option-migration-modal"/>
  </div>
</template>

<script>

import OptionConfigurationMixins from '@/febos/global/empresas/componentes/options/OptionConfigurationsMixin';
import OptionEditionModal from '@/febos/global/empresas/componentes/options/OptionEditionModal';
import TreeItem from '@/components/TreeItem';
import OptionTreeMixins from '@/febos/global/empresas/componentes/options/OptionTreeMixin';
import OptionMigrationModal from '@/febos/global/empresas/componentes/options/OptionMigrationModal';
import FbPaginacion from "@/febos/chile/_vue/componentes/FbPaginacion.vue";

export default {
  name: 'OptionsConfigurations',
  mixins: [OptionConfigurationMixins, OptionTreeMixins],
  components: {
    FbPaginacion,
    TreeItem,
    OptionEditionModal,
    OptionMigrationModal
  },
  data() {
    return {
      pagination: {
        pages: 1,
      },
      optionsCache: {},
      optionsIndex: {},
      tree: {
        name: '',
        children: []
      }
    };
  },
  computed: {
    filteredTree() {
      if (!this.search) {
        return this.tree;
      }
      const word = this.search;
      const newData = JSON.parse(JSON.stringify(this.tree));
      newData.children = this.filterTree(newData.children, word);
      return newData;
    }
  },
  methods: {
    setOptions(options, page = this.page) {
      const currentPage = page || this.page;

      if (currentPage === 1) {
        this.optionsCache = {};
        this.optionsIndex = {};
      }

      const indexedOptions = currentPage === 1 ? {} : { ...this.optionsIndex };
      options.forEach((option) => {
        indexedOptions[option.opcionId] = option;
      });
      this.optionsIndex = indexedOptions;
      this.optionsCache = {
        ...this.optionsCache,
        [currentPage]: options
      };

      const optionsToRender = {};
      const addWithParents = (option) => {
        if (!option || optionsToRender[option.opcionId]) {
          return;
        }
        optionsToRender[option.opcionId] = option;
        if (option.padre && this.optionsIndex[option.padre]) {
          addWithParents(this.optionsIndex[option.padre]);
        }
      };

      options.forEach(addWithParents);

      this.options = Object.values(optionsToRender)
        .map((item) => {
          if (item.padre && !this.optionsIndex[item.padre]) {
            return { ...item, padre: null };
          }
          return item;
        })
        .sort((current, next) => (current.orden || 0) - (next.orden || 0));

      this.tree.children = this.optionToTree(this.options);
    },
    handlePageChange(page) {
      this.loadOptions(page);
    },
    mapAndEditOption(option) {
      const optionToEdit = this.fromItem(option);
      this.editOption(optionToEdit);
    },
    mapAndDeleteOption(option) {
      const optionToDelete = this.fromItem(option);
      this.deleteOption(optionToDelete);
      this.loadOptions();
    }
  }
};
</script>
